"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnableCallForwarder__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwardTarget",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "forwardedCalldata",
                type: "bytes",
            },
        ],
        name: "forwardCall",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class OwnableCallForwarder__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_owner, overrides) {
        return super.getDeployTransaction(_owner, overrides || {});
    }
    deploy(_owner, overrides) {
        return super.deploy(_owner, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.OwnableCallForwarder__factory = OwnableCallForwarder__factory;
//# sourceMappingURL=OwnableCallForwarder__factory.js.map